export default {
  // Nav
  nav_home: 'Home',
  nav_features_amenities: 'Features & Amenities',
  nav_gallery: 'Gallery',
  nav_location: 'Location',
  nav_rules: 'Rules',
  nav_book_now: 'Book Now',
  nav_language: 'Language',

  // Hero — Home
  hero_home_subtitle: 'Lanzarote · Canary Islands',
  hero_home_title: 'Villas Yaiza',
  hero_home_tagline: 'An Unforgettable Experience',
  hero_home_villas: '3 Exclusive Villas',
  hero_home_guests: 'Up to 4 Guests',
  hero_home_location: 'Yaiza & El Golfo',
  hero_home_authentic: 'Authentic Lanzarote',
  hero_home_description: 'Discover our collection of exclusive holiday homes, from modern luxury villas with private pools to traditional Canarian houses with stunning lagoon views.',
  hero_home_explore: 'Explore Our Villas',
  hero_home_check: 'Check Availability',
  hero_home_scroll: 'Scroll',

  // Hero — Villas (shared keys)
  hero_from: 'From',
  hero_night: '/ night',
  hero_check_availability: 'Check Availability',
  hero_book_now: 'Book Now',
  hero_scroll: 'Scroll',

  // Search Bar
  search_check_in: 'Check-in',
  search_check_out: 'Check-out',
  search_guests: 'Guests',
  search_guest_singular: 'Guest',
  search_guest_plural: 'Guests',
  search_search: 'Search Availability',
  search_free_cancel: 'FREE cancellation',
  search_urgency: 'Almost booked out. We recommend booking soon.',
  search_error_dates: 'Please select your check-in and check-out dates.',
  search_error_order: 'Check-out date must be after check-in date.',
  search_error_generic: 'We could not check availability. Please try again.',
  search_checking: 'Checking...',
  search_available_single: 'Available for your dates!',
  search_not_available_single: 'Not available for those dates. Try other dates.',
  search_book_now: 'Book now',
  villas_available: 'Available',
  villas_not_available: 'Not available for your dates',
  villas_no_results: 'No villa is available for the selected dates.',
  villas_available_for_dates: 'villas available for your dates',

  // Why Choose
  why_title: 'Why choose Villas Yaiza?',
  why_subtitle: 'Your private escape in the heart of Lanzarote',
  why_p1: 'Villas Yaiza is a collection of exclusive holiday homes, each entirely private with peaceful surroundings — no shared spaces.',
  why_p2: "Set in the charming village of Yaiza, you're minutes from Timanfaya National Park, Playa Blanca, El Golfo, and Los Hervideros.",
  why_p3: "Our local team is always happy to share insider tips — from hidden beaches to the island's best restaurants.",
  why_contact: 'Talk to our team:',
  why_phone_label: 'phone:',

  // Amenities / Everything you need
  amenities_subtitle: 'Why choose us',
  amenities_title: 'Everything you need',
  feat_private_pool: 'Private Pool',
  feat_heated_pool: 'Heated Pool',
  feat_sea_views: 'Sea Views',
  feat_mountain_views: 'Mountain Views',
  feat_wifi: 'Fast WiFi',
  feat_parking: 'Free Parking',
  feat_kitchen: 'Fully Equipped Kitchen',
  feat_bbq: 'BBQ',
  feat_self_checkin: 'Self Check-in',
  feat_workspace: 'Workspace',
  feat_family: 'Family Friendly',
  feat_garden_terrace: 'Garden & Terrace',
  feat_traditional: 'Traditional Canarian Architecture',
  feat_green_lagoon: 'Sea & Green Lagoon Views',
  feat_private_garden: 'Private Garden',

  // Features section
  features_subtitle: 'What this place offers',
  features_title: 'Features & Amenities',
  features_title_home: 'Features',
  features_exterior: 'Exterior',
  features_interior: 'Interior',
  features_kitchen: 'Kitchen',
  feat_outdoor_shower: 'Outdoor Shower',
  feat_garden: 'Garden',
  feat_covered_terrace: 'Covered Terrace',
  feat_smart_tv: 'Smart TV',
  feat_washing: 'Washing Machine',
  feat_dryer: 'Dryer',
  feat_dishwasher: 'Dishwasher',
  feat_heating: 'Heating',
  feat_fully_equipped: 'Fully Equipped',
  feat_coffee: 'Coffee Maker',
  feat_kettle: 'Kettle',
  feat_fridge: 'Refrigerator',
  feat_oven: 'Oven',
  feat_microwave: 'Microwave',
  feat_kitchenware: 'Kitchenware',
  feat_green_lagoon_views: 'Green Lagoon Views',
  feat_ocean_views: 'Ocean Views',
  feat_outdoor_dining: 'Outdoor Dining',

  // Our Villas
  villas_subtitle: 'Our Collection',
  villas_title: 'Our Villas',
  villas_description: 'Discover our handpicked homes in Lanzarote. From modern luxury villas with private pools to authentic traditional Canarian houses, each property offers a unique island experience.',
  villas_from: 'From',
  villas_night: '/night',
  villas_guests: 'Guests',
  villas_bedrooms: 'Bedrooms',
  villas_bathrooms: 'Bathrooms',
  villa_buenlugar_tagline: 'Private Heated Pool',
  villa_villaflor_tagline: 'Private Heated Pool',
  villa_golfo_tagline: 'Traditional Canarian Home',

  // Layout / Room Distribution
  layout_subtitle: 'Where you will sleep',
  layout_title: 'Room Distribution',
  room_bedroom1: 'Bedroom 1',
  room_bedroom2: 'Bedroom 2',
  room_bathrooms: 'Bathrooms',
  room_bathroom: 'Bathroom',
  bed_double: '1 Double Bed',
  bed_twin: '2 Single Beds',
  bed_queen: '1 Queen Size Bed',
  bed_bunk: 'Bunk Beds',
  bath_2full: '2 Full Bathrooms',
  bath_1full: '1 Full Bathroom',

  // Map / Location
  map_subtitle: 'Where you will be',
  map_nearby: 'Nearby Places',

  // Rules
  rules_subtitle: 'House Rules',
  rules_title: 'Things to know',
  rule_no_smoking: 'No smoking',
  rule_no_parties: 'No parties',
  rule_pets_allowed: 'Pets allowed',
  rule_private_entrance: 'Private entrance',
  rule_calm: 'Calm area',
  rule_family: 'Family friendly',
  license_number: 'License Number',

  // CTA
  cta_buenlugar_title: 'Escape to the tranquility of Lanzarote and enjoy your private heated pool with unforgettable sea and mountain views.',
  cta_buenlugar_subtitle: 'Your luxury retreat awaits in Yaiza. Book now and create memories that last a lifetime.',
  cta_villaflor_title: 'Escape to the tranquility of Lanzarote and enjoy your private heated pool with unforgettable sea and mountain views.',
  cta_villaflor_subtitle: 'Your luxury retreat awaits in Yaiza. Book now and create memories that last a lifetime.',
  cta_golfo_title: 'Escape to the wild beauty of El Golfo and experience authentic Canarian living with unforgettable Green Lagoon and ocean views.',
  cta_golfo_subtitle: 'Your traditional Canarian retreat awaits. Book now and discover the real Lanzarote.',
  cta_home_title: 'Escape to the tranquility of Lanzarote and enjoy your private heated pool with unforgettable sea and mountain views.',
  cta_home_subtitle: 'Your luxury retreat awaits in Yaiza. Book now and create memories that last a lifetime.',
  cta_reserve: 'Reserve Your Stay',

  // Descriptions
  desc_about: 'About the villa',
  desc_about_golfo: 'About the house',
  desc_title: 'Your private retreat in Lanzarote',
  desc_title_golfo: 'Authentic Canarian charm by the Atlantic',
  desc_buenlugar_p1: 'Villa Buenlugar offers a relaxing experience in Yaiza, Lanzarote, accommodating up to 4 guests in complete comfort and privacy.',
  desc_buenlugar_p2: 'The villa features two beautifully appointed bedrooms, two full bathrooms with premium fixtures, and a fully equipped kitchen complete with an Italian coffee maker, kettle, dishwasher, and everything you need to prepare memorable meals.',
  desc_buenlugar_p3: 'Stay connected with high-speed WiFi perfect for video calls, enjoy the dedicated workspace, unwind with the Smart TV, and make use of the heating, fans, washing machine, dryer, crib, and high chair — all thoughtfully provided for your convenience.',
  desc_buenlugar_p4: 'The property is fully accessible and offers self check-in for a seamless arrival experience.',
  desc_villaflor_p1: 'Casa De la Villaflor offers a relaxing experience in Yaiza, Lanzarote, accommodating up to 4 guests in complete comfort and privacy.',
  desc_villaflor_p2: 'The villa features two beautifully appointed bedrooms, two full bathrooms with premium fixtures, and a fully equipped kitchen complete with an Italian coffee maker, kettle, dishwasher, and everything you need to prepare memorable meals.',
  desc_villaflor_p3: 'Stay connected with high-speed WiFi perfect for video calls, enjoy the dedicated workspace, unwind with the Smart TV, and make use of the heating, fans, washing machine, dryer, crib, and high chair — all thoughtfully provided for your convenience.',
  desc_villaflor_p4: 'The property is fully accessible and offers self check-in for a seamless arrival experience.',
  desc_golfo_p1: 'Casa de El Golfo is a lovingly restored traditional Canarian house in the heart of El Golfo, Lanzarote, offering an authentic island experience for up to 4 guests.',
  desc_golfo_p2: 'The house features two cozy bedrooms with wooden beam ceilings, one full bathroom with traditional stone accents, and a fully equipped kitchen complete with an Italian coffee maker, kettle, and everything you need to prepare local meals with fresh island ingredients.',
  desc_golfo_p3: 'Stay connected with high-speed WiFi, enjoy the dedicated workspace, unwind with the Smart TV, and make use of the washing machine, heating, fans, crib, and high chair — all thoughtfully provided for your convenience.',
  desc_golfo_p4: 'The property offers a private garden with BBQ area and outdoor dining, plus stunning views of the iconic Charco Verde (Green Lagoon) and the Atlantic Ocean. The property is fully accessible and offers self check-in for a seamless arrival.',
  license: 'License',

  // Gallery
  gallery_subtitle: 'Photo Gallery',
  gallery_title: 'Explore the villa',
  gallery_title_golfo: 'Explore the house',

  // Footer
  footer_brand: 'Villas Yaiza',
  footer_address: 'Yaiza · Lanzarote\nCanary Islands, Spain',
  footer_quick_links: 'Quick Links',
  footer_info: 'Information',
  footer_contact: 'Contact Us',
  footer_availability: 'Availability',
  footer_amenities: 'Amenities',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms & Conditions',
  footer_license: 'License: E-35-3-0000345',
  footer_name_placeholder: 'Your Name',
  footer_email_placeholder: 'Your Email',
  footer_message_placeholder: 'Your Message',
  footer_send: 'Send Message',
  footer_sending: 'Sending...',
  footer_success: 'Thank you! Your message has been sent successfully.',
  footer_error: 'Something went wrong. Please try again.',
  footer_rights: 'All rights reserved.',

  // Hero specifics
  hero_buenlugar_location: 'Yaiza · Lanzarote · Canary Islands',
  hero_buenlugar_tagline: 'Private Heated Pool · Sea & Mountain Views',
  hero_buenlugar_guests: '4 Guests',
  hero_buenlugar_beds: '2 Bedrooms',
  hero_buenlugar_baths: '2 Bathrooms',
  hero_buenlugar_size: '120 m² (1,292 ft²)',

  hero_villaflor_location: 'Yaiza · Lanzarote · Canary Islands',
  hero_villaflor_tagline: 'Luxury Villa in Yaiza · Lanzarote',
  hero_villaflor_guests: '4 Guests',
  hero_villaflor_beds: '2 Bedrooms',
  hero_villaflor_baths: '2 Bathrooms',
  hero_villaflor_size: '120 m² (1,292 ft²)',

  hero_golfo_location: 'El Golfo · Lanzarote · Canary Islands',
  hero_golfo_tagline: 'Authentic Canarian Home · El Golfo · Lanzarote',
  hero_golfo_guests: '4 Guests',
  hero_golfo_beds: '2 Bedrooms',
  hero_golfo_baths: '1 Bathroom',
  hero_golfo_size: '90 m² (969 ft²)',

  // Booking Calendar
  booking_subtitle: 'Book your stay',
  booking_title: 'Book Your Villa',
  booking_select_date_title: 'Select a date',
  booking_select_date_subtitle: 'Choose your arrival date from the available options',
  booking_select_time_title: 'Select a time',
  booking_select_time_subtitle: 'Pick the time slot that works best for you',
  booking_review_title: 'Review & send request',
  booking_review_subtitle: 'Fill in your details to send your booking request',
  booking_selected_date: 'Selected date',
  booking_selected_time: 'Time',
  booking_modify_time: 'Modify time',
  booking_back: 'Back',
  booking_name_label: 'Full name',
  booking_name_placeholder: 'Your name',
  booking_phone_label: 'Phone',
  booking_phone_placeholder: 'Your phone',
  booking_notes_label: 'Notes (optional)',
  booking_notes_placeholder: 'Anything we should know?',
  booking_submit: 'Send Request',
  booking_submitting: 'Sending...',
  booking_success_title: 'Request sent!',
  booking_success_message: "Thanks! Your request has been sent. Your booking is not confirmed yet — we'll email you to confirm availability.",
  booking_book_another: 'Make another booking',
  booking_loading: 'Loading availability...',
  booking_error: 'We could not load availability. Please try again.',
  booking_retry: 'Retry',
  booking_no_slots: 'No time slots available for this date.',
  booking_prev_month: 'Previous month',
  booking_next_month: 'Next month',
  booking_required_name: 'Please enter your name.',
  booking_required_phone: 'Please enter your phone.',
  booking_required_email: 'Please enter your email.',
  booking_invalid_email: 'Please enter a valid email address.',
  booking_week_sun: 'Sun',
  booking_week_mon: 'Mon',
  booking_week_tue: 'Tue',
  booking_week_wed: 'Wed',
  booking_week_thu: 'Thu',
  booking_week_fri: 'Fri',
  booking_week_sat: 'Sat',
  booking_month_jan: 'January',
  booking_month_feb: 'February',
  booking_month_mar: 'March',
  booking_month_apr: 'April',
  booking_month_may: 'May',
  booking_month_jun: 'June',
  booking_month_jul: 'July',
  booking_month_aug: 'August',
  booking_month_sep: 'September',
  booking_month_oct: 'October',
  booking_month_nov: 'November',
  booking_month_dec: 'December',

  // Villa Booking (date range)
  booking_step_dates: 'Dates',
  booking_step_details: 'Details',
  booking_select_dates_title: 'Choose your dates',
  booking_select_dates_subtitle: 'Select your check-in and check-out from the available dates',
  booking_pick_checkin: 'Select your check-in date',
  booking_pick_checkout: 'Now select your check-out date',
  booking_check_in_label: 'Check-in',
  booking_check_out_label: 'Check-out',
  booking_night_singular: 'night',
  booking_night_plural: 'nights',
  booking_email_label: 'Email',
  booking_email_placeholder: 'Your email',
  booking_continue: 'Continue',
  booking_clear: 'Clear selection',
  booking_invalid_range: 'The selected range includes unavailable dates.',
  booking_legend_available: 'Available',
  booking_legend_booked: 'Booked',
  booking_legend_selected: 'Selected',
  booking_total: 'Total',
  booking_not_confirmed: 'Please note: your booking is not confirmed until you receive a confirmation email from us.',
};